import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { Modal, ModalCloseButton, ModalDescription, ModalTitle } from "@air/primitive-modal";
import { useState } from "react";
export const CustomFieldDeleteModal = (param)=>{
    let { onClose, handleConfirmDeleteClick } = param;
    const [isDeleting, setIsDeleting] = useState(false);
    const onDeleteClick = async ()=>{
        try {
            setIsDeleting(true);
            await handleConfirmDeleteClick();
        } finally{
            setIsDeleting(false);
            onClose();
        }
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: true,
        onDismiss: onClose,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: "flex justify-between gap-1",
                        children: [
                            /*#__PURE__*/ _jsx(ModalTitle, {
                                children: "Are you sure?"
                            }),
                            /*#__PURE__*/ _jsx(ModalCloseButton, {
                                className: "shrink-0",
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ModalDescription, {
                        children: "Deleting this field will remove it from every asset and board in your workspace."
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-6 flex justify-end gap-3",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        disabled: isDeleting,
                        appearance: "ghost",
                        color: "grey",
                        onClick: onClose,
                        size: "large",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        "data-testid": "CUSTOM_FIELD_DELETE_CONFIRM",
                        isLoading: isDeleting,
                        appearance: "filled",
                        color: "red",
                        size: "large",
                        onClick: onDeleteClick,
                        children: "Delete"
                    })
                ]
            })
        ]
    });
};
